export default __webpack_public_path__ + "static/media/feedback.6057d4bb.webp";